import React, { useState, useEffect, useRef } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
} from "react-native";

import { Picker } from "@react-native-picker/picker";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import PredefinedExercise from "../Firestore/PredefinedExercise";

import { v4 as uuidv4 } from "uuid";

import { useTranslation } from "react-i18next";
import { useScreenDimensions, useDevice } from "../_layout";

// const getTypeString = (typeKey) => {
//   return PredefinedExercise.ExerciseTypes[typeKey];
// };
// const getTypeKey = (typeString) => {
//   const typeEntries = Object.entries(PredefinedExercise.ExerciseTypes);
//   for (const [key, value] of typeEntries) {
//     if (value === typeString) {
//       return key;
//     }
//   }
//   return null; // or a default value, if you prefer
// };

const AddPredefinedExerciseView = ({
  isVisible,
  onClose,
  coach,
  predefinedExercise,
  title,
  setTitle,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const [predefinedName, setPredefinedName] = useState(
    predefinedExercise && predefinedExercise.name ? predefinedExercise.name : ""
  );

  const predefinedText =
    predefinedExercise && predefinedExercise.name
      ? predefinedExercise.name
      : "newPredefinedExercise-string";
  const text = predefinedExercise
    ? "editPredefinedExercise-string"
    : "addPredefinedExercise-string";

  // Prevent keyboard events from reaching other components when modal is open
  useEffect(() => {
    if (!isVisible) return;

    const handleKeyDown = (event) => {
      // Stop the event from propagating to other listeners (like SearchBar)
      event.stopPropagation();
    };

    // Add event listener with capture=true to catch events before they reach other listeners
    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isVisible]);

  const cancel = () => {
    setPredefinedName("");
    setTitle();
    onClose();
  };

  const Buttons = ({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";
    const canAdd = predefinedName !== "";
    // const selectedTypeString = getTypeString(selectedType);
    // const sortedCustoms =
    //   coach.customPredefinedExercises &&
    //   coach.customPredefinedExercises.sort((a, b) => a.order - b.order);
    // const N =
    //   coach.customPredefinedExercises &&
    //   coach.customPredefinedExercises.length - 1;

    const [isHovered, setIsHovered] = useState(false);

    const typeItems = (coach.customPredefinedExercises || []).filter(
      (item) => item.type === title
    );

    const highestOrder = typeItems.reduce((maxOrder, item) => {
      const orderValue = item?.order;
      if (typeof orderValue === "number" && Number.isFinite(orderValue)) {
        return Math.max(maxOrder, orderValue);
      }
      return maxOrder;
    }, -Infinity);

    const nextOrder = highestOrder === -Infinity ? 1000 : highestOrder + 1;

    const Save = () => {
      if (canAdd) {
        const newPredefinedExercise = new PredefinedExercise(
          uuidv4(),
          predefinedName,
          predefinedName,
          nextOrder,
          title,
          "",
          "",
          false,
          false,
          false,
          0,
          0,
          0,
          0,
          0,
          []
        );
        coach.customPredefinedExercises.push(newPredefinedExercise);
        coach.updateCoachTransactionExercises(newPredefinedExercise.id);
        coach.startOrResetBatchTimer();

        onClose();
      }
    };

    return bool ? (
      <TouchableOpacity
        onPress={Save}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.8 : canAdd ? 1 : 0.7,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={GlobalStyles.modalView}>
            <View
              style={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={Fonts.bold18Centered}>{t(text)}</Text>
              <TextInput
                style={[
                  GlobalStyles.textInputStyle,
                  {
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={t(predefinedText)}
                placeholderTextColor={Colors.grayColor}
                value={predefinedName}
                onChangeText={setPredefinedName}
                maxLength={65}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                autoFocus={true}
              />

              <View style={{ marginVertical: 20, width: "100%" }}>
                <View style={GlobalStyles.HStack}>
                  <Text style={Fonts.bold14}>{t("typeDots-string")}</Text>
                  <Text style={Fonts.medium14}>{t(title)}</Text>
                </View>
              </View>
            </View>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  justifyContent: "center",
                  width: "100%",
                  justifyContent: "space-around",
                  // marginTop: 20,
                },
              ]}
            >
              <Buttons bool={false} />
              <Buttons bool={true} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    // flexDirection: "row",
    // alignItems: "center",
  },
  textInputStyle: {
    width: "50%",

    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    marginTop: 10,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
    //flex: 1,
  },
});

export default AddPredefinedExerciseView;
